import { COMPLETED_MAGIC_ID, VERIFIED_MAGIC_ID } from '@alltrails/shared/utils/listHelpers';
import { PageStrings } from '@alltrails/shared/utils/pageStringHelpers';
import { Context } from 'types/Context';
import { Filters } from 'types/Search';
import { Sort } from 'types/Search/Sort';
import { EXPLORE } from 'utils/constants/SearchAnalyticsConstants';
import logError from 'utils/logError';
import { getAnalyticsTags } from 'utils/requests/algolia_requests';
import { SearchFiltersUtil } from 'utils/search_filters_util';

const ET_PHOTO_USER_SLUG = 'alltrails-user';

export type Args = {
  algoliaIndex: any;
  atMaps: any;
  context: Context;
  filters: Filters;
  handlePlaceSearchResults?: any;
  handleSearchResults?: any;
  handleUserResults?: any;
  initialUserSlug: string;
  isMobileWidth: boolean;
  listMethods: any;
  page: string;
};

export const analyticsTags = (context: Context, searchText: string) =>
  getAnalyticsTags({
    user: context.currentUser,
    locale: context.languageRegionCode,
    origin: EXPLORE,
    mobile: context.mobileBrowser,
    searchText,
    system: false
  });

const legacyPerformSearch = ({
  algoliaIndex,
  atMaps,
  context,
  filters,
  handlePlaceSearchResults,
  handleSearchResults,
  handleUserResults,
  initialUserSlug,
  isMobileWidth,
  listMethods,
  page
}: Args) => {
  // Sanity check that our index is ready to go!
  // Dont search on trail map page, or if quick-draw is enabled
  const isCertainPage = [
    PageStrings.EXPLORE_TRAIL_MAP_PAGE,
    PageStrings.EXPLORE_USERS_TRACKS_MAP_PAGE,
    PageStrings.EXPLORE_USERS_MAPS_MAP_PAGE,
    PageStrings.EXPLORE_PENDING_PAGE
  ].includes(page);
  if (!algoliaIndex || isCertainPage) {
    return;
  }

  if ([PageStrings.EXPLORE_USERS_TRACKS_PAGE, PageStrings.EXPLORE_USERS_MAPS_PAGE].includes(page)) {
    if (initialUserSlug == ET_PHOTO_USER_SLUG || !atMaps) {
      return;
    }

    handleUserResults(SearchFiltersUtil.customSearch(atMaps, filters, context, isMobileWidth));
    return;
  }

  // search for recordings or trails
  const completedIds = Object.keys(listMethods.itemsInListOfType(COMPLETED_MAGIC_ID, 'trail'));
  const verifiedIds = Object.keys(listMethods.itemsInListOfType(VERIFIED_MAGIC_ID, 'trail'));

  // TODO This approach may not be sustainable long term. See https://alltrails.atlassian.net/browse/DISCO-554
  if (filters.sort[Sort.NEWLY_ADDED]?.selected) {
    filters.has_profile_photo = true;
    filters.isMinimumViableContent = true;
  } else {
    filters.has_profile_photo = null;
    filters.isMinimumViableContent = null;
  }

  const algoliaQueryObject = SearchFiltersUtil.createAlgoliaQueryObject({
    filters,
    mobileWidth: isMobileWidth,
    page,
    completedIds,
    verifiedIds,
    analyticsTags: analyticsTags(context, filters.queryTerm)
  });

  algoliaIndex
    .search(filters.queryTerm || '', algoliaQueryObject)
    .then(handleSearchResults)
    .catch(logError);

  // search for places (for admin filter)
  if (context.adminUser) {
    const algoliaAreaQueryObject = SearchFiltersUtil.createAlgoliaLocQueryObject(['area', 'place'], filters, isMobileWidth, page);
    algoliaIndex
      .search('', algoliaAreaQueryObject)
      .then(handlePlaceSearchResults)
      .catch(logError);
  }
};

export default legacyPerformSearch;
